module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content year"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h1', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$route.params.year))])], 1), (_vm.exhibitions.length > 0) ? _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.exhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.year + '/' + exhibition.uid
        }
      }
    }, [(_vm.hero(exhibition)) ? _c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.hero(exhibition),
        "alt": _vm.altText(exhibition)
      }
    }), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.date(exhibition)))])])]) : _vm._e(), (!_vm.hero(exhibition)) ? _c('div', {
      staticClass: "screen-small"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": "/static/images/sun.jpg",
        "alt": _vm.altText(exhibition)
      }
    }), _c('div', {
      staticClass: "noimagecaptions"
    }, [_c('h2', {
      staticClass: "title h-l italic"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h2', {
      staticClass: "dates h-sm"
    }, [_vm._v(_vm._s(_vm.date(exhibition)))])])]) : _vm._e()])], 1)
  }))]) : _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('h2', {
    staticClass: "standin"
  }, [_vm._v("Full exhibitions list coming soon ...")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b111468"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExhibitionsYear.vue
// module id = 246
// module chunks = 1